var map = {
	"./SystemMessage.vue": "./js/monbi/system-messages/SystemMessage.vue",
	"./ViewSystemMessages.vue": "./js/monbi/system-messages/ViewSystemMessages.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/monbi/system-messages sync .+\\.vue$";